import { gql } from 'apollo-boost';
import { useMutation } from '../';

const mutation = gql`
  mutation deleteNotificationRule(
    $id: Int!,
  ) {
  deleteNotificationRule(
    id: $id,
  ) {
      success
    }
  }
`;

export function useDeleteNotificationRule() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
